import { render, staticRenderFns } from "./GestionarGanador.vue?vue&type=template&id=3a4f26c5"
import script from "./GestionarGanador.vue?vue&type=script&lang=js"
export * from "./GestionarGanador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports